import React from 'react';
import { isTestEnv } from 'common/report/util/env';
import { ReportBannersReact } from 'common/widgets/report-banners';
import { Entity } from 'common/report/util/saved-entities/types';
import { HeatMap } from 'common/widgets/heat-maps/types';
import { HeatMapPlayer } from 'common/widgets/heat-maps/player';
import { useHeatMapURLs } from 'common/widgets/heat-maps/util';
import styles from './index.module.styl';
type HeatMapPageMainProps = {
  heatMap: HeatMap;
  heatMapEntity: Entity;
  onEditHeatMap: (heatMap: HeatMap) => void;
  canEdit: boolean;
};
export function HeatMapPageMain(props: HeatMapPageMainProps) {
  const {
    heatMapsClickEventCountsLoading,
    getHeatMapClickEventCountsByUrl
  } = useHeatMapURLs();
  return <div className={styles.mainWrapper} data-sentry-component="HeatMapPageMain" data-sentry-source-file="index.tsx">
      {!isTestEnv() && <ReportBannersReact />}
      <main className={styles.main}>
        <HeatMapPlayer currentHeatMap={props.heatMap} onEditHeatMap={heatMap => {
        props.onEditHeatMap(heatMap);
      }} canEdit={props.canEdit} heatMapsClickEventCountsLoading={heatMapsClickEventCountsLoading} getHeatMapClickEventCountsByUrl={getHeatMapClickEventCountsByUrl} data-sentry-element="HeatMapPlayer" data-sentry-source-file="index.tsx" />
      </main>
    </div>;
}